import { MapLocation } from '../models/map.models';
import { MapServicesProviderInterface } from '../ports/secondary/map-services-provider.interface';

export const MapActionTypes = {
    LOAD_VALUES: '[map] LOAD_VALUES',
    SET_SELECTED_SHOP: '[map] SET_SELECTED_SHOP',
    REMOVE_SELECTED_SHOP: '[map] REMOVE_SELECTED_SHOP',
    SET_STATE_TOOLTIP: '[map] SET_STATE_TOOLTIP',
    SET_VALUE_TOOLTIP: '[map] SET_VALUE_TOOLTIP',
    TOOGLE_STATE_TOOLTIP: '[map] TOOGLE_STATE_TOOLTIP',
    SET_PARAMS: '[map] SET_PARAMS',
    CONFIRM_SELECTED_PLACE: '[map] CONFIRM_SELECTED_PLACE',
    CONFIRM_SELECTED_DELIVERYPOINT: '[map] CONFIRM_SELECTED_DROPPOINT',
    RESET_STATE: '[map] RESET_STATE',
    START_EFFECTS: '[map] START_EFFECTS',
    STOP_EFFECTS: '[map] STOP_EFFECTS',
    MAP_MARKER_CLICKED: '[map] MAP_MARKER_CLICKED',
};

export interface MapMarkerClickedEventPayload {
    clickedLocation: MapLocation;
    mapServicesProvider: MapServicesProviderInterface;
}
